// Generated by ReScript, PLEASE EDIT WITH CARE


var partner_lead_info_title = "Partner Lead Info";

var lead_id_info_title = "Lead ID";

var dashboard_flow_title = "Journey";

var onboarding_status_title = "Onboarding Status";

var timestamp_title = "Date & Time";

var contact_number_text = "Contact Number";

var driver_name_text = "Driver Name";

var rc_number_text = "RC Number";

var driver_location_text = "Location";

var body_type_text = "Body Type";

var model_text = "Model";

var vehicle_type_text = "Vehicle Type";

var owner_phone_text = "Owner Phone";

var owner_name_text = "Owner Name";

var payment_history_title = "Reg. Fee Payment History";

var amount_title = "Amount";

var payment_status_title = "Payment Status";

var transaction_id_title = "Transaction ID";

var time_stamp_title = "Time Stamp";

var raise_ticket_label = "Raise Ticket";

var view_ticket_label = "View Ticket";

var waitlist_ticket_status = "Waitlist";

var shortlist_ticket_status = "Shortlist";

var doc_verification_ticket_status = "Doc Verification";

var verfied_ticket_status = "Verified";

var rejected_ticket_status = "Rejected";

var empty_lead_data_message = "Not a valid driver-lead";

var empty_reg_fee_payment_message = "No Reg. fee payment history";

export {
  partner_lead_info_title ,
  lead_id_info_title ,
  dashboard_flow_title ,
  onboarding_status_title ,
  timestamp_title ,
  contact_number_text ,
  driver_name_text ,
  rc_number_text ,
  driver_location_text ,
  body_type_text ,
  model_text ,
  vehicle_type_text ,
  owner_phone_text ,
  owner_name_text ,
  payment_history_title ,
  amount_title ,
  payment_status_title ,
  transaction_id_title ,
  time_stamp_title ,
  raise_ticket_label ,
  view_ticket_label ,
  waitlist_ticket_status ,
  shortlist_ticket_status ,
  doc_verification_ticket_status ,
  verfied_ticket_status ,
  rejected_ticket_status ,
  empty_lead_data_message ,
  empty_reg_fee_payment_message ,
  
}
/* No side effect */
